import React from "react";
import { ReactComponent as IconFilter } from "../../assets/images/icons/IconFilter.svg";

const DefaultOutline = ({ children, onClick }) => {
  return (
    <button
      className="group border border-gray-300 rounded-md px-2 py-1.5 text-sm flex items-center gap-2 
hover:bg-primary hover:text-secondary text-primary-text-muted"
      onClick={onClick}
    >
      <IconFilter className="fill-current group-hover:text-white" />
      {children}
    </button>

    // <button className='border border-gray-300 rounded-md px-2 py-1.5 text-sm flex items-center text-primary-text-muted gap-2  hover:bg-primary hover:text-secondary'>
    //     <IconFilter className='hover:bg-white' fill='#c7c7c7' />
    //     {children}
    // </button>
  );
};

export default DefaultOutline;
